export const colorMatchToPublishType = (type: string) => {
  switch (type) {
    case "meta":
      return "magenta";
    case "guideline":
      return "red";
    case "review":
      return "volcano";
    case "multi":
      return "green";
    case "random":
      return "cyan";
    case "trial":
      return "blue";
    case "caseReports":
      return "purple";
    case "clinical":
      return "geekblue";
    case "edt":
      return "gold";
    case "letter":
      return "lime";
    default:
      return "default";
  }
};

export const colorMatchIFRange = (ifNumber: number = -1) => {
  if (ifNumber > 60) {
    return "#f5222d";
  }
  if (ifNumber > 30) {
    return "#fa541c";
  }
  if (ifNumber > 20) {
    return "#722ed1";
  }
  if (ifNumber > 10) {
    return "#1890ff";
  }
  if (ifNumber > 5) {
    return "#52c41a";
  }
  if (ifNumber > 0) {
    return "#faad14";
  }
  return "#8c8c8c";
};

export function getRandomColor() {
  const arr = [
    "#5B8FF9",
    "#5AD8A6",
    "#5D7092",
    "#F6BD16",
    "#E8684A",
    "#6DC8EC",
    "#9270CA",
    "#FF9D4D",
    "#269A99",
    "#FF99C3",
  ];
  return arr[Math.floor(Math.random() * (arr.length - 1))];
}
